export default [
    'Bags',
    'Cartons'
]